import { AssetPriceSource, AssetTab } from './enums'

export const ASSET_MODAL_TITLE = 'Asset'
export const ASSET_MODAL_TITLE_NEW = 'New asset'

export const CURRENCY_MODAL_TITLE = 'Currency'
export const CURRENCY_MODAL_TITLE_NEW = 'New currency'

export const INCOME_ACCOUNT_MODAL_TITLE = 'Income account'
export const INCOME_ACCOUNT_MODAL_TITLE_NEW = 'New income account'

export const EXPENSE_ACCOUNT_MODAL_TITLE = 'Expense account'
export const EXPENSE_ACCOUNT_MODAL_TITLE_NEW = 'New expense account'

export const ASSET_TABS = {
  [AssetTab.SECURITY_MASTER]: 'Security',
  [AssetTab.PRICES]: 'Prices',
  [AssetTab.TAGS]: 'Tags',
  [AssetTab.DOCUMENTS]: 'Documents',
  [AssetTab.CONTACTS]: 'Contacts',
}

export const CURRENCY_TABS = {
  [AssetTab.SECURITY_MASTER]: 'Security',
  [AssetTab.PRICES]: 'Prices',
  [AssetTab.TAGS]: 'Tags',
}

export const ASSET_PRICES_LIST = [
  { value: AssetPriceSource.ALL, label: 'All' },
  { value: AssetPriceSource.MANUAL, label: 'Manual' },
  { value: AssetPriceSource.OVERRIDE, label: 'Override' },
  { value: AssetPriceSource.CONNECTOR, label: 'Connector' },
  { value: AssetPriceSource.SECURITY_MASTER, label: 'Security Master' },
  {
    value: AssetPriceSource.SECURITY_MASTER_ADJ,
    label: 'Security Master Adjusted',
  },
]

export const ASSET_PRICES_SECURITY = [
  AssetPriceSource.SECURITY_MASTER,
  AssetPriceSource.SECURITY_MASTER_ADJ,
]

export const ASSET_PRICE_SOURCE_EDITABLE = [
  { value: AssetPriceSource.MANUAL, label: 'Manual' },
  { value: AssetPriceSource.OVERRIDE, label: 'Override' },
]

export const SOURCE_TOOLTIP = '<strong>Manual:</strong> Manual price affects only the specific timeline period starting from <br />the date of the manual price. Subsequent prices will take effect.<br /><strong>Override:</strong> Override price affects all timelines starting from the date of the <br />override price. Subsequent prices, except for another override, are ignored.'
